import { useQuery } from "@tanstack/react-query";
import { authQueryOptions } from "@/services/auth/auth.options";

/**
 * Whether the current user may create a form layout (`ManageForms`).
 * Org-admin type form editors use this until save endpoints are split
 * between create and edit-layout actions.
 */
export function useCanCreateFormLayout(): boolean {
	const query = useQuery(
		authQueryOptions.checkAction({
			name: "CreateFormLayout",
			entityType: null,
			entityId: null,
		}),
	);
	return query.data === true;
}
